// Available Endorsements Response (POST applications/availableEndorsements)
// {
//   "availableEndorsements": {
//     "workplaceViolenceCoverage": "{\"limits\":\"50000/50000\"}"
//   }
// }
//
// Application Update Payload (POST applications)
// {
//   "endorsements": {
//     "workplaceViolenceCoverage": {
//       "limits": "50000/50000"
//     }
//   }
// }
import { useSelector, useDispatch } from 'react-redux';
import { setWorkplaceViolenceCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { selectWorkplaceViolenceCoverageLimit, selectCheckedEndorsements } from '../../../../selectors/application';
import styled from 'styled-components';
import EndorsementCard from '../../EndorsementCard';
import UnderwritingRadioGroup from '../../shared/UnderwritingRadioGroup';
import { selectLoadingState } from '../../../../selectors';
import CenteredLoadingSpinner from '../../../AddOns/shared/CenteredLoadingSpinner';
import { config, FIFTY_THOUSAND_LIMIT_VALUE, ONE_HUNDRED_THOUSAND_LIMIT_VALUE } from './WorkplaceViolence.config';

const { endorsementKey: ENDORSEMENT_KEY, label: LABEL, description: DESCRIPTION } = config;

const DEFAULT_LIMITS_OPTIONS = [
  { label: '$50,000 per event / $50,000 agg', value: FIFTY_THOUSAND_LIMIT_VALUE },
  { label: '$100,000 per event / $100,000 agg', value: ONE_HUNDRED_THOUSAND_LIMIT_VALUE },
];
// only EPLI has "options" from available endorsements
const WorkplaceViolence = () => {
  const dispatch = useDispatch();
  const isQuoteLoading = useSelector(selectLoadingState);
  const selectedLimit = useSelector(selectWorkplaceViolenceCoverageLimit);
  const isSelected = useSelector(selectCheckedEndorsements).includes(ENDORSEMENT_KEY);
  const limitsOptions = DEFAULT_LIMITS_OPTIONS;

  const handleCheckboxChange = (checked: boolean) => {
    dispatch(setCheckedEndorsement(ENDORSEMENT_KEY, checked));
    if (checked) {
      dispatch(setWorkplaceViolenceCoverage({ limits: FIFTY_THOUSAND_LIMIT_VALUE }));
    } else {
      dispatch(setWorkplaceViolenceCoverage(null));
    }
  };

  const handleLimitsChange = (newValue: string) => {
    dispatch(setWorkplaceViolenceCoverage({ limits: newValue }));
  };

  return (
    <EndorsementCard
      endorsementKey={ENDORSEMENT_KEY}
      label={LABEL}
      description={
        <>
          <p>{DESCRIPTION}</p>
          <BoldText>Deductible: $0</BoldText>
        </>
      }
      isSelected={isSelected}
      onCheckboxChange={handleCheckboxChange}
      hasExpandableContent={true}
    >
      <SubQuestionsContainer>
        {isQuoteLoading && <CenteredLoadingSpinner useAltColor />}
        <UnderwritingRadioGroup
          questionCopy="Select your coverage limit:"
          options={limitsOptions}
          selectedValue={selectedLimit}
          onChange={handleLimitsChange}
          name="workplace-violence-limits"
          isActive={!isQuoteLoading}
        />
      </SubQuestionsContainer>
    </EndorsementCard>
  );
};

const BoldText = styled.p`
  font-weight: 600;
`;

const SubQuestionsContainer = styled.div`
  position: relative;
`;

export default WorkplaceViolence;
